import KelompokUpahSubcontApi from './KelompokUpahSubcontApi';

export default KelompokUpahSubcontApi;
